const floorStatics = {
  p0_w: {
    sectionPath: '/floor_0w',
    locationKey: 'p0_w',
    sectionKey: 'WOMAN',
    floorKey: '0w',
    section: 'p0_w.section.name',
    floor: 'p0_w.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W.jpg?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_0m',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p0_w.path.floorMap.linkName',
        title: 'p0_w.path.floorMap.title',
        info: 'p0_w.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.floorMap.description.title',
          content: 'p0_w.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_0w',
        path: '/beauty',
        exact: true,
        location: 'beauty',
        linkName: 'p0_w.path.beauty.linkName',
        title: 'p0_w.path.beauty.title',
        info: 'p0_w.path.beauty.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W_Beauty_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W_Beauty.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.beauty.description.title',
          content: 'p0_w.path.beauty.description.content',
        },
      },
      {
        sectionPath: '/floor_0w',
        path: '/lingerie',
        exact: true,
        location: 'lingerie',
        linkName: 'p0_w.path.lingerie.linkName',
        title: 'p0_w.path.lingerie.title',
        info: 'p0_w.path.lingerie.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W_Lenceria_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W_Lenceria.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.lingerie.description.title',
          content: 'p0_w.path.lingerie.description.content',
        },
      },
      {
        sectionPath: '/floor_0w',
        path: '/shoes',
        exact: true,
        location: 'shoes',
        linkName: 'p0_w.path.shoes.linkName',
        title: 'p0_w.path.shoes.title',
        info: 'p0_w.path.shoes.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W_Calzado_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W_Calzado.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.shoes.description.title',
          content: 'p0_w.path.shoes.description.content',
        },
      },
      {
        sectionPath: '/floor_0w',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p0_w.path.pickUpSize.linkName',
        title: 'p0_w.path.pickUpSize.title',
        info: 'p0_w.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W_EncuentraTalla_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.pickUpSize.description.title',
          content: 'p0_w.path.pickUpSize.description.content',
        },
      },
      {
        sectionPath: '/floor_0w',
        path: '/fittingRooms',
        exact: true,
        location: 'fittingRooms',
        linkName: 'p0_w.path.fittingRooms.linkName',
        title: 'p0_w.path.fittingRooms.title',
        info: 'p0_w.path.fittingRooms.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W_TurnoProbadores_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W_TurnoProbadores.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.fittingRooms.description.title',
          content: 'p0_w.path.fittingRooms.description.content',
        },
      },
      {
        sectionPath: '/floor_0w',
        path: '/onlinePickup',
        exact: true,
        location: 'onlinePickup',
        linkName: 'p0_w.path.onlinePickup.linkName',
        title: 'p0_w.path.onlinePickup.title',
        info: 'p0_w.path.onlinePickup.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W_PuntoRecogidaOnline_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W_PuntoRecogidaOnline.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.onlinePickup.description.title',
          content: 'p0_w.path.onlinePickup.description.content',
        },
      },
      {
        sectionPath: '/floor_0w',
        path: '/onlineReturn',
        exact: true,
        location: 'onlineReturn',
        linkName: 'p0_w.path.onlineReturn.linkName',
        title: 'p0_w.path.onlineReturn.title',
        info: 'p0_w.path.onlineReturn.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W_DevolucionesOnline_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W_DevolucionesOnline.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.onlineReturn.description.title',
          content: 'p0_w.path.onlineReturn.description.content',
        },
      },
      {
        sectionPath: '/floor_0w',
        path: '/selfCheckout',
        exact: true,
        location: 'selfCheckout',
        linkName: 'p0_w.path.selfCheckout.linkName',
        title: 'p0_w.path.selfCheckout.title',
        info: 'p0_w.path.selfCheckout.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W_Autocobro_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W_Autocobro.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.selfCheckout.description.title',
          content: 'p0_w.path.selfCheckout.description.content',
        },
      },
      {
        sectionPath: '/floor_0w',
        path: '/zaraCafe',
        exact: true,
        location: 'zaraCafe',
        linkName: 'p0_w.path.zaraCafe.linkName',
        title: 'p0_w.path.zaraCafe.title',
        info: 'p0_w.path.zaraCafe.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W_ZaraCafe_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_W_ZaraCafe.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.zaraCafe.description.title',
          content: 'p0_w.path.zaraCafe.description.content',
        },
      },
    ],
  },
  p0_m: {
    sectionPath: '/floor_0m',
    locationKey: 'p0_m',
    sectionKey: 'MAN',
    floorKey: '0m',
    section: 'p0_m.section.name',
    floor: 'p0_m.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_M.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_M.jpg?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_0m',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p0_m.path.floorMap.linkName',
        title: 'p0_m.path.floorMap.title',
        info: 'p0_m.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_M.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_M.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_m.path.floorMap.description.title',
          content: 'p0_m.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_0m',
        path: '/selfCheckout',
        exact: true,
        location: 'selfCheckout',
        linkName: 'p0_m.path.selfCheckout.linkName',
        title: 'p0_m.path.selfCheckout.title',
        info: 'p0_m.path.selfCheckout.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_M_Autocobro_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_M_Autocobro.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_m.path.selfCheckout.description.title',
          content: 'p0_m.path.selfCheckout.description.content',
        },
      },
      {
        sectionPath: '/floor_0m',
        path: '/fittingRooms',
        exact: true,
        location: 'fittingRooms',
        linkName: 'p0_m.path.fittingRooms.linkName',
        title: 'p0_m.path.fittingRooms.title',
        info: 'p0_m.path.fittingRooms.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_M_TurnoProbadores_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_M_TurnoProbadores.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_m.path.fittingRooms.description.title',
          content: 'p0_m.path.fittingRooms.description.content',
        },
      },
      {
        sectionPath: '/floor_0m',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p0_m.path.pickUpSize.linkName',
        title: 'p0_m.path.pickUpSize.title',
        info: 'p0_m.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_M_EncuentraTalla_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_M_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_m.path.pickUpSize.description.title',
          content: 'p0_m.path.pickUpSize.description.content',
        },
      },
    ],
  },
  p0_k: {
    sectionPath: '/floor_0k',
    locationKey: 'p0_k',
    sectionKey: 'KIDS',
    floorKey: '0k',
    section: 'p0_k.section.name',
    floor: 'p0_k.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_K.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_K.jpg?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_0k',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p0_k.path.floorMap.linkName',
        title: 'p0_k.path.floorMap.title',
        info: 'p0_k.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_K.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_K.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_k.path.floorMap.description.title',
          content: 'p0_k.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_0k',
        path: '/selfCheckout',
        exact: true,
        location: 'selfCheckout',
        linkName: 'p0_k.path.selfCheckout.linkName',
        title: 'p0_k.path.selfCheckout.title',
        info: 'p0_k.path.selfCheckout.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_K_Autocobro_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_K_Autocobro.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_k.path.selfCheckout.description.title',
          content: 'p0_k.path.selfCheckout.description.content',
        },
      },
      {
        sectionPath: '/floor_0k',
        path: '/shoes',
        exact: true,
        location: 'shoes',
        linkName: 'p0_k.path.shoes.linkName',
        title: 'p0_k.path.shoes.title',
        info: 'p0_k.path.shoes.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_K_Calzado_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_K_Calzado.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_k.path.shoes.description.title',
          content: 'p0_k.path.shoes.description.content',
        },
      },
      {
        sectionPath: '/floor_0k',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 'p0_k.path.pickUpSize.linkName',
        title: 'p0_k.path.pickUpSize.title',
        info: 'p0_k.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_K_EncuentraTalla_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3488_P0_K_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_k.path.pickUpSize.description.title',
          content: 'p0_k.path.pickUpSize.description.content',
        },
      },
    ],
  },
};

const StoreSuportedLanguages = [
  {
    language: 'ar-LB',
    name: 'عربي',
  },
  {
    language: 'en-GB',
    name: 'English',
  },
];

const HomeStatics = {
  splash:
    'https://static.zara.net/photos/contents/multichannel/maps/ZARA_LONDRES___ONC_008.jpg?ts=1631201500000',
  prehome:
    'https://static.zara.net/photos/contents/multichannel/maps/3488_ZARA_MALL_OF_THE_EMIRATES_IMG.jpg?ts=1631201500000',
  prehomeColor: '#fff',
};

const StoreConfig = {
  floorStatics,
  StoreSuportedLanguages,
  HomeStatics,
};

export default StoreConfig;
